export default function getNotificationsApiUrl() {
  const environment = process.env.NEXT_PUBLIC_GOVLAUNCH_ENV || process.env.NODE_ENV || "development";

  if (environment === "test") {
    return "http://localhost:4001";
  }

  return process.env.NEXT_PUBLIC_NOTIFICATIONS_API_URL;
}
